import axios from "axios";
import { API_URL, CLOVER_URL, OTP_URL } from "./constants";

const fundraiserSessionConfig = (sessionToken) => ({
  headers: sessionToken ? { Authorization: `Bearer ${sessionToken}` } : {},
});

const api_endpoints = {
  register: (firstName, lastName, organization_id, email, password, otp) => {
    return axios.post(`${API_URL}/register`, {
      first_name: firstName,
      last_name: lastName,
      organization_id: organization_id,
      email: email,
      password: password,
      otp: otp,
    });
  },
  login: (email, password, rememberMe) => {
    return axios.post(`${API_URL}/login`, {
      email: email,
      password: password,
      remember_me: rememberMe,
    });
  },
  send_otp: (email, organization_id) => {
    return axios.post(`${OTP_URL}/send-otp`, {
      email: email,
      organization_id: organization_id,
    });
  },
  emailExists: (email) => {
    return axios.post(`${API_URL}/emailExists`, {
      email: email,
    });
  },
  sendOTPForgotPassword: (email) => {
    return axios.post(`${OTP_URL}/sendOTPForgotPassword`, {
      email: email,
    });
  },
  verifyOTPForgotPassword: (email, otp) => {
    return axios.post(`${OTP_URL}/verifyOTPForgotPassword`, {
      email: email,
      otp: otp,
    });
  },
  resetPassword: (email, password) => {
    return axios.post(`${API_URL}/resetPassword`, {
      email: email,
      password: password,
    });
  },
  allDonationsStats: (
    organization_id,
    emplacement,
    campaign,
    kiosk_id,
    startdate,
    enddate,
    donation_source
  ) => {
    return axios.get(
      `${API_URL}/allDonationsStats?organization_id=${organization_id}&emplacement=${emplacement}&campaign=${campaign}&kiosk_id=${kiosk_id}&startdate=${startdate}&enddate=${enddate}&donation_source=${donation_source}`
    );
  },
  getCampaignsStatus: (organization_id) => {
    return axios.get(
      `${API_URL}/getCampaignsStatus?organization_id=${organization_id}`
    );
  },
  getCampaignsRepartition: (organization_id) => {
    return axios.get(
      `${API_URL}/getCampaignsRepartition?organization_id=${organization_id}`
    );
  },
  getCampaigns: (
    organization_id,
    campaignName,
    campaignCreator,
    donationAmount,
    status,
    acceptCash,
    is_archived,
    is_deleted,
    is_fundraiser
  ) => {
    return axios.get(
      `${API_URL}/getCampaigns?organization_id=${organization_id}&campaignName=${campaignName}&campaignCreator=${campaignCreator}&donationAmount=${donationAmount}&status=${status}&acceptCash=${acceptCash}&is_archived=${is_archived}&is_deleted=${is_deleted}&is_fundraiser=${is_fundraiser}`
    );
  },
  createCampaign: (data) => {
    return axios.post(`${API_URL}/createCampaign`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getCampaign: (campaign_id, location, kiosk, startDate, endDate, donation_source) => {
    return axios.get(
      `${API_URL}/getCampaign?campaign_id=${campaign_id}&location=${location}&kiosk=${kiosk}&startDate=${startDate}&endDate=${endDate}&donation_source=${donation_source}`
    );
  },
  getCampaignTranslations: (campaign_id) => {
    return axios.get(
      `${API_URL}/getCampaignTranslations?campaign_id=${campaign_id}`
    );
  },
  getCampaignTransactions: (
    campaign_id,
    location,
    kiosk,
    startDate,
    endDate,
    donation_source
  ) => {
    return axios.get(
      `${API_URL}/getCampaignTransactions?campaign_id=${campaign_id}&location=${location}&kiosk=${kiosk}&startDate=${startDate}&endDate=${endDate}&donation_source=${donation_source}`
    );
  },
  addCashToCampaign: (
    payloadOrCampaignId,
    cash_amount,
    inserted_by,
    organization_id,
    date_donated,
    donor_id,
    notes
  ) => {
    const payload =
      typeof payloadOrCampaignId === "object" && payloadOrCampaignId !== null
        ? payloadOrCampaignId
        : {
            campaign_id: payloadOrCampaignId,
            cash_amount,
            inserted_by,
            organization_id,
            date_donated,
            donor_id,
            notes,
          };

    return axios.post(`${API_URL}/addCashToCampaign`, payload);
  },
  setArchiveCampaignStatus: ({ campaign_id, archive_status }) => {
    return axios.post(`${API_URL}/setArchiveCampaignStatus`, {
      campaign_id,
      archive_status,
    });
  },
  getCampaignsTransacitons: (campaign_id, date) => {
    return axios.get(
      `${API_URL}/getCampaignTransactions?campaign_id=${campaign_id}&date=${date}`
    );
  },
  getCampaignTransactionsStats: (
    campaign_id,
    location,
    kiosk,
    startDate,
    endDate,
    donation_source
  ) => {
    return axios.get(
      `${API_URL}/getCampaignTransactionsStats?campaign_id=${campaign_id}&location=${location}&kiosk=${kiosk}&startDate=${startDate}&endDate=${endDate}&donation_source=${donation_source}`
    );
  },
  deleteCampaign: (campaign_id) => {
    return axios.post(`${API_URL}/deleteCampaign`, {
      campaign_id: campaign_id,
    });
  },
  editCampaign: (data) => {
    return axios.post(`${API_URL}/editCampaign`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getCampaignFundraiserUrl: (campaignId) =>
    axios.get(`${API_URL}/campaigns/${campaignId}/fundraiser-url`),
  ensureCampaignFundraiserUrl: (campaignId) =>
    axios.post(`${API_URL}/campaigns/${campaignId}/fundraiser-url`),
  deleteCampaignFundraiserUrl: (campaignId) =>
    axios.delete(`${API_URL}/campaigns/${campaignId}/fundraiser-url`),
  getUsers: (
    organization_id,
    first_name,
    last_name,
    email,
    created_at,
    is_active,
    is_verified,
    is_super_user,
    is_deleted
  ) => {
    return axios.get(
      `${API_URL}/getUsers?organization_id=${organization_id}&first_name=${first_name}&last_name=${last_name}&email=${email}&created_at=${created_at}&is_active=${is_active}&is_super_user=${is_super_user}&is_verified=${is_verified}&is_deleted=${is_deleted}`
    );
  },
  getUserById: (user_id) => {
    return axios.get(`${API_URL}/users/${user_id}`);
  },
  updateUser: (user_id, payload) => {
    return axios.patch(`${API_URL}/users/${user_id}`, payload);
  },
  resetUserKioskPin: (user_id) => {
    return axios.patch(`${API_URL}/users/${user_id}/reset-kiosk-pin`, {});
  },
  deleteUser: (user_id) => {
    return axios.delete(`${API_URL}/users/${user_id}`);
  },
  restoreUser: (user_id) => {
    return axios.patch(`${API_URL}/users/${user_id}/restore`, {});
  },
  toggleUserActive: (user_id) => {
    return axios.patch(`${API_URL}/users/${user_id}/toggle-active`, {});
  },
  createLocation: (data) => {
    return axios.post(`${API_URL}/createLocation`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  editLocation: (data) => {
    return axios.post(`${API_URL}/editLocation`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getLocations: (organization_id, location_name, person_responsible) => {
    return axios.get(
      `${API_URL}/getLocations?organization_id=${organization_id}&location_name=${location_name}&person_responsible=${person_responsible}`
    );
  },
  getLocation: (organization_id, location_name) => {
    return axios.get(
      `${API_URL}/getLocation?organization_id=${organization_id}&location_name=${location_name}`
    );
  },
  createKiosk: (data) => {
    return axios.post(`${API_URL}/createKiosk`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  editKiosk: (data) => {
    return axios.post(`${API_URL}/editKiosk`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getKiosks: (organization_id, kioskname, location, is_active, search) =>
  axios.get(`${API_URL}/getKiosks`, {
    params: {
      organization_id,
      // unified search (only if explicitly provided)
      ...(search ? { search } : {}),
      // fallback: if user only typed kiosk name or location
      ...(!search && kioskname && !location ? { kioskname } : {}),
      ...(!search && location && !kioskname ? { location } : {}),
      ...(!search && kioskname && location ? { kioskname, location } : {}),

      ...(typeof is_active === "boolean" ? { is_active } : {}),
    },
  }),

  getPieChartTransactions: (
    organization_id,
    emplacement,
    campaign,
    kiosk,
    startdate,
    enddate,
    donation_source
  ) => {
    return axios.get(
      `${API_URL}/getPieChartTransactions?organization_id=${organization_id}&emplacement=${emplacement}&campaign=${campaign}&kiosk=${kiosk}&startdate=${startdate}&enddate=${enddate}&donation_source=${donation_source}`
    );
  },
  getTransactions: (
    organization_id,
    amount,
    location_name,
    donor_email,
    campaignName,
    kioskName,
    startdate,
    enddate
  ) => {
    return axios.get(
      `${API_URL}/getTransactions?organization_id=${organization_id}&amount=${amount}&location_name=${location_name}&donor_email=${donor_email}&campaignName=${campaignName}&kioskName=${kioskName}&startdate=${startdate}&enddate=${enddate}`
    );
  },
  getKioskByID: (kiosk_id) => {
    return axios.get(`${API_URL}/getKioskByID?kiosk_id=${kiosk_id}`);
  },
  getOrganizations: (
    legal_name,
    address,
    phone,
    owner_name,
    is_archived,
    federal_tax_number
  ) => {
    return axios.get(
      `${API_URL}/getOrganizations?legal_name=${legal_name}&address=${address}&phone=${phone}&owner_name=${owner_name}&is_archived=${is_archived}&federal_tax_number=${federal_tax_number}`
    );
  },
  getOrganization: (organization_id) => {
    return axios.get(
      `${API_URL}/getOrganization?organization_id=${organization_id}`
    );
  },
  getLocationCount: (organization_id) => {
    return axios.get(
      `${API_URL}/getLocationCount?organization_id=${organization_id}`
    );
  },
  getCampaignCount: (organization_id) => {
    return axios.get(
      `${API_URL}/getCampaignCount?organization_id=${organization_id}`
    );
  },
  getBorneCount: (organization_id) => {
    return axios.get(
      `${API_URL}/getBorneCount?organization_id=${organization_id}`
    );
  },
  getUsersCount: (organization_id) => {
    return axios.get(
      `${API_URL}/getUsersCount?organization_id=${organization_id}`
    );
  },
  getKiosksCount: (organization_id) => {
    return axios.get(
      `${API_URL}/getKiosksCount?organization_id=${organization_id}`
    );
  },
  getUserCount: (organization_id) => {
    return axios.get(
      `${API_URL}/getUserCount?organization_id=${organization_id}`
    );
  },
  createOrganization: (formData, country_id) => {
    return axios.post(`${API_URL}/createOrganization`, {
      ...formData,
      country_id,
    });
  },
  editOrganization: (formData, organization_id, country_id) => {
    delete formData.owner;
    const resolvedCountryId =
      country_id && typeof country_id === "object"
        ? country_id.id ?? country_id._id ?? null
        : country_id;
    return axios.post(`${API_URL}/editOrganization`, {
      formData: formData,
      organization_id: organization_id,
      country_id: resolvedCountryId,
    });
  },
  deleteOrganization: (organization_id) => {
    return axios.post(`${API_URL}/deleteOrganization`, {
      organization_id: organization_id,
    });
  },
  getSuperUserCode: () => {
    return axios.get(`${API_URL}/super-users/code`);
  },
  getSuperUsers: (filters = {}, config = {}) => {
    return axios.get(`${API_URL}/super-users`, {
      params: filters,
      ...config,
    });
  },
  getSuperUserById: (user_id) => {
    return axios.get(`${API_URL}/super-users/${user_id}`);
  },
  createSuperUser: (payload) => {
    return axios.post(`${API_URL}/super-users`, payload);
  },
  updateSuperUser: (user_id, payload) => {
    return axios.patch(`${API_URL}/super-users/${user_id}`, payload);
  },
  deleteSuperUser: (user_id) => {
    return axios.delete(`${API_URL}/super-users/${user_id}`);
  },
  restoreSuperUser: (user_id) => {
    return axios.patch(`${API_URL}/super-users/${user_id}/restore`, {});
  },
  toggleSuperUserActive: (user_id) => {
    return axios.patch(`${API_URL}/super-users/${user_id}/toggle-active`, {});
  },
  validateSuperUserCode: (kiosk_code) => {
    return axios.post(`${API_URL}/super-users/code/validate`, {
      kiosk_code,
    });
  },
  createUser: (first_name, last_name, email, organization_id, location_id, kiosk_code) => {
    return axios.post(`${API_URL}/createUser`, {
      first_name: first_name,
      last_name: last_name,
      email: email,
      organization_id: organization_id,
      ...(location_id !== undefined ? { location_id: location_id } : {}),
      ...(kiosk_code !== undefined ? { kiosk_code: kiosk_code } : {}),
    });
  },
  createUserOTP: (email, is_regular_user, is_super_user, is_owner) => {
    return axios.post(`${OTP_URL}/createUserOTP`, {
      email: email,
      is_regular_user: is_regular_user,
      is_super_user: is_super_user,
      is_owner: is_owner,
    });
  },
  checkUserOTP: (email) => {
    return axios.get(`${OTP_URL}/checkUserOTP`, {
      params: { email },
      // A non-verified user can legitimately have no pending OTP anymore.
      // Treat 404 as an expected empty state so the global Axios error
      // interceptor does not display "Code OTP introuvable" as an error.
      validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 404,
    });
  },
  validateUser: (email, password, otpcode) => {
    return axios.post(`${API_URL}/validateUser`, {
      email: email,
      password: password,
      otpcode: otpcode,
    });
  },
  setKioskActiveStatus: (kiosk_id, active_status) => {
    return axios.post(`${API_URL}/setKioskActiveStatus`, {
      kiosk_id: kiosk_id,
      active_status: active_status,
    });
  },
  setClientID: (client_id) => {
    return axios.post(`${CLOVER_URL}/setClientID`, {
      client_id: client_id,
    });
  },
  getClientID: () => {
    return axios.post(`${CLOVER_URL}/getClientID`);
  },
  getDonorProfileFromTempURL: (url) => {
    return axios.get(`${API_URL}/getDonorProfileFromTempURL?url=${url}`);
  },
  saveProfileDonor: (
    url,
    email,
    adresse,
    first_name,
    last_name,
    phone,
    company
  ) => {
    return axios.post(`${API_URL}/saveProfileDonor`, {
      url: url,
      email: email,
      adresse: adresse,
      first_name: first_name,
      last_name: last_name,
      phone: phone,
      company: company,
    });
  },
  importDonations: (data, campaign_id, organization_id, user_id) => {
    return axios.post(`${API_URL}/importDonations`, {
      data: JSON.stringify(data),
      campaign_id: campaign_id,
      organization_id: organization_id,
      user_id: user_id,
    });
  },
  getTransactionsYears: (organization_id) => {
    return axios.get(
      `${API_URL}/getTransactionsYears?organization_id=${organization_id}`
    );
  },
  getDonors: (search, sort, organization_id) => {
    return axios.get(
      `${API_URL}/getDonors?organization_id=${organization_id}&search=${search}&sort=${sort}`
    );
  },
  getDonor: (email, organization_id) => {
    const e = encodeURIComponent(String(email ?? "").trim());
    const org = organization_id
      ? `&organization_id=${encodeURIComponent(String(organization_id))}`
      : "";
    return axios.get(`${API_URL}/getDonor?email=${e}${org}`);
  },
  getDonorById : (id) =>{
    return axios.get(`${API_URL}/donor/${id}`);
  },
  createDonor : (payload) =>{
    return axios.post(`${API_URL}/donors`,payload)
  },
  getDonorTransactions: (
    organization_id,
    email,
    amount,
    campaignId,
    startdate,
    enddate,
    payment_type
  ) => {
    return axios.get(`${API_URL}/getDonorTransactions`, {
      params: {
        email: String(email ?? "").trim(),
        organization_id,
        amount,
        campaignId,
        startdate,
        enddate,
        payment_type,
      },
    });
  },
  getKioskAppVersion: (environment_target) => {
    return axios.get(
      `${API_URL}/getKioskAppVersion?environment_target=${environment_target}`
    );
  },
  getKioskAppLink: (environment_target) => {
    return axios.get(
      `${API_URL}/getKioskAppLink?environment_target=${environment_target}`
    );
  },
  generateReceipt: (receiptData, config = {}) => {
    return axios.post(
      `${API_URL}/donor/receipts/generate`,
      receiptData,
      config
    );
  },
  previewReceipt: (receiptData) => {
    return axios.post(`${API_URL}/donor/receipts/generate`, { ...receiptData, preview: true }, { responseType: "blob" });
  },
  getReceiptCampaigns: (donorId, organizationId, year, startDate, endDate) => {
    return axios.get(`${API_URL}/donor/receipts/campaigns`, {
      params: {
        ...(donorId ? { donor_id: donorId } : {}),
        organization_id: organizationId,
        year,
        start_date: startDate,
        end_date: endDate,
      },
    });
  },
  getDonorLastReceiptStatus: (donor_id, organization_id) => {
    return axios.get(
      `${API_URL}/getDonorLastReceiptStatus?organization_id=${organization_id}&donor_id=${donor_id}`
    );
  },
  getKioskPingStatus: (kiosk_id, date) => {
    return axios.get(
      `${API_URL}/getKioskPingStatus?date=${date}&kiosk_id=${kiosk_id}`
    );
  },
  getKiosksPingStatus: (organization_id, startDate, endDate) => {
    return axios.get(
      `${API_URL}/getKiosksPingStatus?organization_id=${organization_id}&startDate=${startDate}&endDate=${endDate}`
    );
  },
  getLocales: (organization) => {
    return axios.get(`${API_URL}/getLocales?organization=${organization}`);
  },
  getAllLocales: () => {
    return axios.get(`${API_URL}/getAllLocales`);
  },
  getCountryLocales: (countryId) => {
    return axios.get(`${API_URL}/getCountryLocales?countryId=${countryId}`);
  },
  editCountryLocales: (data) => {
    return axios.post(`${API_URL}/editCountryLocales`, data);
  },
  editCountryTimezones: (data) => {
    return axios.post(`${API_URL}/editCountryTimezones`, data);
  },
  getCountries: (name, code) => {
    return axios.get(`${API_URL}/getCountries?name=${name}&code=${code}`);
  },
  getPageTranslation: (locale, page_name, platform) => {
    return axios.get(
      `${API_URL}/getPageTranslation?locale=${locale}&page_name=${page_name}&platform=${platform}`
    );
  },
  getCountryLocales: (countryId) => {
    return axios.get(`${API_URL}/getCountryLocales?countryId=${countryId}`);
  },
  getOrganizationLocale: (organizationId) => {
    return axios.get(
      `${API_URL}/getOrganizationLocale?organizationId=${organizationId}`
    );
  },
  getAllLocales: () => {
    return axios.get(`${API_URL}/getAllLocales`);
  },
  editOrganizationLocales: (organizationId, locales) => {
    return axios.post(`${API_URL}/editOrganizationLocales`, {
      organizationId: organizationId,
      locales: locales,
    });
  },
  editCampaignTranslations: (campaignId, translations) => {
    return axios.post(`${API_URL}/editCampaignTranslations`, {
      campaignId: campaignId,
      translations: translations,
    });
  },
  getPages: (platform) => {
    return axios.get(`${API_URL}/getPages?platform=${platform}`);
  },
  getPagesTranslations: (platform) => {
    return axios.get(`${API_URL}/getPagesTranslations?platform=${platform}`);
  },
  exportTranslationsCsv: (platform) => {
    return axios.get(`${API_URL}/translations/export?platform=${platform}`, {
      responseType: "blob",
    });
  },
  previewTranslationsCsv: (payload) => {
    return axios.post(`${API_URL}/translations/preview`, payload);
  },
  importTranslationsCsv: (payload) => {
    return axios.post(`${API_URL}/translations/import`, payload);
  },
  editTranslations: (page_id, locale_id, translations) => {
    return axios.post(`${API_URL}/editTranslations`, {
      page_id,
      locale_id,
      translations,
    });
  },
  emailTransactionExport: (data) => {
    return axios.post(`${API_URL}/emailTransactionExport`, data);
  },
  createRecurringTransactionExport: (data) => {
    return axios.post(`${API_URL}/createRecurringTransactionExport`, data);
  },
  getAllTimezones: () => {
    return axios.get(`${API_URL}/getAllTimezones`);
  },
  getCountryTimezones: (countryId) => {
    return axios.get(`${API_URL}/getCountryTimezones?countryId=${countryId}`);
  },
  getOrganizationCountryTimezone: (organizationId) => {
    return axios.get(
      `${API_URL}/getOrganizationCountryTimezone?organizationId=${organizationId}`
    );
  },
  getTranslations: (locale, platform) => {
    return axios.get(
      `${API_URL}/getTranslations?locale=${locale}&platform=${platform}`
    );
  },
  getLocaleBasedTranslations: (locale, platform) => {
    return axios.get(
      `${API_URL}/getLocaleBasedTranslations?locale=${locale}&platform=${platform}`
    );
  },
  createPromise: (promiseData) => {
    return axios.post(`${API_URL}/createPromise`, promiseData);
  },
  getPromises: (
    organization_id,
    campaign_name,
    donor_name,
    email,
    phone,
    promise_amount,
    status,
    payment_type,
    promise_type,
    given_amount,
    startdate,
    enddate
  ) => {
    return axios.get(
      `${API_URL}/getPromises?organization_id=${organization_id}&campaign_name=${campaign_name}&donor_name=${donor_name}&email=${email}&phone=${phone}&promise_amount=${promise_amount}&status=${status}&payment_type=${payment_type}&promise_type=${promise_type}&given_amount=${given_amount}&startdate=${startdate}&enddate=${enddate}`
    );
  },
  addAmountToCampaignPromise: (
    campaign_promise_id,
    amount,
    inserted_by,
    donation_date,
    payment_type,
    organization_id,
    cheque_number
  ) => {
    return axios.post(`${API_URL}/addAmountToCampaignPromise`, {
      campaign_promise_id: campaign_promise_id,
      amount: amount,
      inserted_by: inserted_by,
      donation_date: donation_date,
      payment_type: payment_type,
      organization_id: organization_id,
      cheque_number: cheque_number,
    });
  },
  getCampaignPromiseTransactions: (
    campaign_promise_id,
    amount,
    donation_date,
    inserted_by,
    payment_type
  ) => {
    return axios.get(
      `${API_URL}/getCampaignPromiseTransactions?campaign_promise_id=${campaign_promise_id}&amount=${amount}&donation_date=${donation_date}&inserted_by=${inserted_by}&payment_type=${payment_type}`
    );
  },
  getPromise: (promise_id) => {
    return axios.get(`${API_URL}/getPromise?promise_id=${promise_id}`);
  },
  getPromisesForDonorCampaign: (promise_id) => {
    return axios.get(`${API_URL}/promises/donor-campaign`, {
      params: { promise_id },
    });
  },
  getDonorPromises: (donor_id, organization_id) => {
    return axios.get(`${API_URL}/donors/${donor_id}/promises`, {
      params: { organization_id },
    });
  },
  sendPromisePaymentLink: (promise_id) => {
    return axios.post(`${API_URL}/promises/${promise_id}/payment-link`);
  },
  getPromiseReminderLogs: ({
    organization_id,
    donor_id,
    promise_id,
    page = 1,
    limit = 25,
  } = {}) => {
    return axios.get(`${API_URL}/promise-reminders`, {
      params: { organization_id, donor_id, promise_id, page, limit },
    });
  },
  editPromise: (campaign_promise_id, promise_amount, status) => {
    return axios.post(`${API_URL}/editPromise`, {
      campaign_promise_id: campaign_promise_id,
      promise_amount: promise_amount,
      status: status,
    });
  },
  getCampaignAndOrganization: (campaign_id) => {
    return axios.get(
      `${API_URL}/getCampaignAndOrganization?campaign_id=${campaign_id}`
    );
  },
  createPromiseByFundraiserForm: (promiseData) => {
    return axios.post(`${API_URL}/createPromiseByFundraiserForm`, promiseData);
  },
    getFundraiserLanding: (token) =>
      axios.get(`${API_URL}/fundraiser-url/${token}`),
  setArchiveOrganizationStatus: (organizationArchiveData) => {
    return axios.post(
      `${API_URL}/setArchiveOrganizationStatus`,
      organizationArchiveData
    );
    
  },
  editEmailCommunicationSettings: (organization_id, language) => {
    return axios.post(`${API_URL}/editEmailCommunicationSettings`, {
      organization_id: organization_id,
      email_language: language,
    });
  },
  updateDonorById: (id, body) => {
    return axios.patch(`${API_URL}/donor/${id}`, body);
  },
  resendDonorProfileLink: (id, payload = {}) => {
  return axios.post(`${API_URL}/donor/${id}/profile-link`, payload);
},
  sendDonorPaymentMethodLink: ({ donor_id, organization_id, instrument_type }) => {
    return axios.post(`${API_URL}/donors/${donor_id}/payment-method-link`, {
      organization_id,
      instrument_type,
    });
  },
  getDonorPaymentMethodLink: (token) => {
    return axios.get(`${API_URL}/donor-payment-method/${token}`);
  },
  getDonorPaymentMethodCloverPakms: (token) => {
    return axios.get(`${API_URL}/donor-payment-method/${token}/clover`);
  },
  submitDonorPaymentMethodCard: (token, body) => {
    return axios.post(`${API_URL}/donor-payment-method/${token}/card`, body);
  },
  submitDonorPaymentMethodAch: (token, body) => {
    return axios.post(`${API_URL}/donor-payment-method/${token}/ach`, body);
  },
  updateOrganizationFederalTaxNumber: (federal_tax_number) => {
    return axios.patch(`${API_URL}/organization/federal-tax-number`, { federal_tax_number });
  },
  uploadOrganizationLogo: (organization_id, file) => {
    const formData = new FormData();
    formData.append("organization_id", organization_id);
    formData.append("logo", file);
    return axios.post(`${API_URL}/organization/logo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getDonorReceiptsGrouped: (donorId, orgId) => {
    return axios.get(`${API_URL}/donor/receipts/grouped?donor_id=${donorId}&organization_id=${orgId}`)
  },
  getReceiptContent: (receiptId) =>{
    return axios.get(`${API_URL}/donor/receipts/${receiptId}/content`)
  },
  softDeleteReceipt: (receiptId, body) =>{
    return axios.patch(`${API_URL}/donor/receipts/${receiptId}/delete`, body)
  },
  restoreReceipt: (receiptId) =>{
    return axios.patch(`${API_URL}/donor/receipts/${receiptId}/restore`)
  },
  getReceiptPdf: (receiptId) => {
    return axios.get(`${API_URL}/donor/receipts/${receiptId}/pdf`, {
      responseType: "blob",
    });
  },
  setReceiptValidity: (receiptId, is_valid, reason = "") => {
    return axios.patch(`${API_URL}/donor/receipts/${receiptId}/valid`, { is_valid, reason })
  },
  getFrequentLocales: (limit = 10) => {
    return axios.get(`${API_URL}/getFrequentLocales?limit=${limit}`);
  },
  addPage: (payload) => {
    return axios.post(`${API_URL}/addPage`, payload);
  },
  addPageTexts: (pageId, keys) => {
    return axios.patch(`${API_URL}/pages/${pageId}/texts`, { add: keys });
  },

  listDonorPaymentMethods: (donorId, organizationId) => {
    return axios.get(`${API_URL}/donors/${donorId}/payment-methods`, {
      params: { organization_id: organizationId },
    });
  },

  updatePaymentMethod: (id, body) => {
    return axios.patch(`${API_URL}/payment-methods/${id}`, body);
  },

  findTransactionsForPaymentMethod: (id, params) => {
    return axios.get(`${API_URL}/payment-methods/${id}/transactions`, {
      params,
    });
  },

  mapTransactionsToDonor: (id, body) => {
    return axios.post(`${API_URL}/payment-methods/${id}/map-transactions`, body);
  },
  // ===== Recurring Plans =====
  listRecurringPlans: (organizationId, { q, active = true, limit = 100 } = {}) => {
    return axios.get(`${API_URL}/recurring/plans`, {
      params: { organization_id: organizationId, q, active: String(active), limit },
    });
  },

  createRecurringPlan: (body) => {
    // body: { organization_id, name, amount, frequency, description? }
    return axios.post(`${API_URL}/recurring/plans`, body);
  },

  updateRecurringPlan: (id, body) => {
    // body: partial { name?, amount?, frequency?, description?, is_active? }
    return axios.patch(`${API_URL}/recurring/plans/${id}`, body);
  },

  archiveRecurringPlan: (id) => {
    return axios.delete(`${API_URL}/recurring/plans/${id}`);
  },

  // ===== Recurring Subscriptions =====
  listRecurringSubscriptions: (organizationId, { donor_id, status, limit = 200 } = {}) => {
    return axios.get(`${API_URL}/recurring/subscriptions`, {
      params: { organization_id: organizationId, donor_id, status, limit },
    });
  },

  getRecurringSubscription: (id) => {
    return axios.get(`${API_URL}/recurring/subscriptions/${id}`);
  },

  createRecurringSubscription: (body) => {
    return axios.post(`${API_URL}/recurring/subscriptions`, body);
  },

  updateRecurringSubscription: (id, body) => {
    return axios.patch(`${API_URL}/recurring/subscriptions/${id}`, body);
  },

  pauseRecurringSubscription: (id) => {
    return axios.post(`${API_URL}/recurring/subscriptions/pause/${id}`);
  },

  resumeRecurringSubscription: (id) => {
    return axios.post(`${API_URL}/recurring/subscriptions/resume/${id}`);
  },

  cancelRecurringSubscription: (id) => {
    return axios.post(`${API_URL}/recurring/subscriptions/cancel/${id}`);
  },

  getNextRecurringPayment: (organizationId) => {
    return axios.get(`${API_URL}/recurring/subscriptions/next`, {
      params: { organization_id: organizationId },
    }).then(response => response.data).catch(error => {
      console.error('Failed to get next recurring payment:', error);
      return { next: null };
    });
  },

  listRecurringChargeAttempts: (organizationId, { donorId, subscriptionId, status, limit = 200 } = {}) => {
    return axios.get(`${API_URL}/recurring/charge-attempts`, {
      params: {
        organization_id: organizationId,
        donor_id: donorId,
        subscription_id: subscriptionId,
        status,
        limit,
      },
    });
  },

  listRecurringTransactions: (organizationId, { donorId, subscriptionId, limit = 200 } = {}) => {
    return axios.get(`${API_URL}/recurring/transactions`, {
      params: {
        organization_id: organizationId,
        donor_id: donorId,
        subscription_id: subscriptionId,
        limit,
      },
    });
  },

  refundRecurringTransaction: (transactionId, { amount, reason }) => {
    return axios.post(`${API_URL}/recurring/transactions/${transactionId}/refund`, {
      amount,
      reason,
    });
  },

  // ===== Processing (cron/manual) =====
  runDueRecurringSubscriptions: (organizationId, { limit = 100 } = {}) => {
    return axios.post(`${API_URL}/recurring/subscriptions/run-due`, null, {
      params: { organization_id: organizationId, limit },
    });
  },

  runNowRecurringSubscription: (id) => {
    return axios.post(`${API_URL}/recurring/subscriptions/${id}/run-now`);
  },

  // ===== Tokenization (clover/ForteACH) =====
  tokenizeCloverCard: ({ organization_id, donor_id, token, brand, first6, last4, exp_month, exp_year, cardholderName, billingAddress }) => {
    return axios.post(`${API_URL}/tokenization/clover/card`, {
      organization_id, donor_id,
      token, brand, first6, last4, exp_month, exp_year,
      cardholderName, billingAddress
    }).then(r => r.data);
  },

  tokenizeForteAch: ({ organization_id, donor_id, one_time_token, forte_customer_token, last4, account_type, bank_name }) => {
    return axios.post(`${API_URL}/tokenization/forte/ach`, {
      organization_id, donor_id,
      one_time_token, forte_customer_token,
      last4, account_type, bank_name
    }).then(r => r.data);
  },
  forteFindOrCreateCustomer: ({ organization_id, donor_id }) =>
    axios.post(`${API_URL}/forte/customers/find-or-create`, { organization_id, donor_id })
        .then(r => r.data),
  getCloverPakms: ({ organization_id }) =>
    axios.get(`${CLOVER_URL}/pakms`, { params: { organization_id } }).then(r => r.data),

  // ===== One-Time Charges =====
  createOneTimeCharge: (body) => {
    return axios.post(`${API_URL}/one-time/charge`, body).then(r => r.data);
  },

  createOneTimeChargeTest: (body) => {
    return axios.post(`${API_URL}/one-time/charge-test`, body).then(r => r.data);
  },

  createOneTimeCustomerTest: (body) => {
    return axios.post(`${API_URL}/one-time/customer-test`, body).then(r => r.data);
  },

  refundOneTimeCharge: (transactionId, body) => {
    return axios.post(`${API_URL}/one-time/refund/${transactionId}`, body).then(r => r.data);
  },

  listOneTimeTransactions: (organizationId, { donor_id, status, limit = 200 } = {}) => {
    return axios.get(`${API_URL}/one-time/transactions`, {
      params: { organization_id: organizationId, donor_id, status, limit },
    }).then(r => r.data);
  },

  getOneTimeTransaction: (transactionId) => {
    return axios.get(`${API_URL}/one-time/transactions/${transactionId}`).then(r => r.data);
  },

  // ===== Fundraiser Payment Flow =====
  sendFundraiserOTP: (token, body) => {
    return axios.post(`${API_URL}/fundraiser/${token}/send-otp`, body);
  },

  verifyFundraiserOTP: (token, body) => {
    return axios.post(`${API_URL}/fundraiser/${token}/verify-otp`, body);
  },

  createFundraiserDonor: (token, body, sessionToken) => {
    return axios.post(`${API_URL}/fundraiser/${token}/create-donor`, body, fundraiserSessionConfig(sessionToken));
  },

  updateFundraiserDonor: (token, body, sessionToken) => {
    return axios.put(`${API_URL}/fundraiser/${token}/update-donor`, body, fundraiserSessionConfig(sessionToken));
  },

  createFundraiserPromise: (token, body, sessionToken) => {
    return axios.post(`${API_URL}/fundraiser/${token}/create-promise`, body, fundraiserSessionConfig(sessionToken));
  },
  getFundraiserPromises: (token, sessionToken) => {
    return axios.get(
      `${API_URL}/fundraiser/${token}/promises`,
      fundraiserSessionConfig(sessionToken)
    );
  },

  getFundraiserCloverPakms: (token, organizationId, sessionToken) => {
    return axios.get(
      `${API_URL}/fundraiser/${token}/clover-pakms?organization_id=${organizationId}`,
      fundraiserSessionConfig(sessionToken)
    );
  },

  getFundraiserForteConfig: (token, sessionToken) => {
    return axios.get(`${API_URL}/fundraiser/${token}/forte-config`, fundraiserSessionConfig(sessionToken));
  },

  tokenizeFundraiserCard: (token, body, sessionToken) => {
    return axios.post(`${API_URL}/fundraiser/${token}/tokenize-card`, body, fundraiserSessionConfig(sessionToken));
  },

  tokenizeFundraiserACH: (token, body, sessionToken) => {
    return axios.post(`${API_URL}/fundraiser/${token}/tokenize-ach`, body, fundraiserSessionConfig(sessionToken));
  },

  processFundraiserCharge: (token, body, sessionToken) => {
    return axios.post(`${API_URL}/fundraiser/${token}/charge`, body, fundraiserSessionConfig(sessionToken));
  },

  createFundraiserSubscription: (token, body, sessionToken) => {
    return axios.post(`${API_URL}/fundraiser/${token}/subscribe`, body, fundraiserSessionConfig(sessionToken));
  },

};

export default api_endpoints;
